export default "__VITE_ASSET__CLaroqT6__"